var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocuments = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9375 8.854C10.9375 8.57786 11.1614 8.354 11.4375 8.354H17.5573C17.8334 8.354 18.0573 8.57786 18.0573 8.854C18.0573 9.13015 17.8334 9.354 17.5573 9.354H11.4375C11.1614 9.354 10.9375 9.13015 10.9375 8.854Z",
    fill: "#08081B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9375 11.979C10.9375 11.7029 11.1614 11.479 11.4375 11.479H17.5573C17.8334 11.479 18.0573 11.7029 18.0573 11.979C18.0573 12.2551 17.8334 12.479 17.5573 12.479H11.4375C11.1614 12.479 10.9375 12.2551 10.9375 11.979Z",
    fill: "#08081B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9375 15.104C10.9375 14.8279 11.1614 14.604 11.4375 14.604H17.5573C17.8334 14.604 18.0573 14.8279 18.0573 15.104C18.0573 15.3801 17.8334 15.604 17.5573 15.604H11.4375C11.1614 15.604 10.9375 15.3801 10.9375 15.104Z",
    fill: "#08081B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9375 18.229C10.9375 17.9529 11.1614 17.729 11.4375 17.729H17.5573C17.8334 17.729 18.0573 17.9529 18.0573 18.229C18.0573 18.5051 17.8334 18.729 17.5573 18.729H11.4375C11.1614 18.729 10.9375 18.5051 10.9375 18.229Z",
    fill: "#08081B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3125 4.1875V20.3125C21.3125 20.9976 21.0403 21.6547 20.5559 22.1392C20.0714 22.6237 19.4143 22.8958 18.7292 22.8958H10.3958C9.71069 22.8958 9.05361 22.6237 8.56914 22.1392C8.08467 21.6547 7.8125 20.9976 7.8125 20.3125L7.8125 6.77083C7.8125 6.08569 8.08467 5.42861 8.56914 4.94414C9.05361 4.45967 9.71069 4.1875 10.3958 4.1875L21.3125 4.1875ZM20.3125 5.1875L10.3958 5.1875C9.97591 5.1875 9.57318 5.35431 9.27625 5.65125C8.97932 5.94818 8.8125 6.35091 8.8125 6.77083L8.8125 20.3125C8.8125 20.7324 8.97932 21.1352 9.27625 21.4321C9.57318 21.729 9.97591 21.8958 10.3958 21.8958H18.7292C19.1491 21.8958 19.5518 21.729 19.8488 21.4321C20.1457 21.1352 20.3125 20.7324 20.3125 20.3125V5.1875Z",
    fill: "#08081B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44414 2.86064C5.92861 2.37618 6.58569 2.104 7.27083 2.104H18.1875V4.68734H17.1875V3.104H7.27083C6.85091 3.104 6.44818 3.27082 6.15125 3.56775C5.85432 3.86468 5.6875 4.26741 5.6875 4.68734V18.229C5.6875 18.6489 5.85431 19.0517 6.15125 19.3486C6.44818 19.6455 6.85091 19.8123 7.27083 19.8123H8.3125V20.8123H7.27083C6.58569 20.8123 5.92861 20.5402 5.44414 20.0557C4.95967 19.5712 4.6875 18.9141 4.6875 18.229V4.68734C4.6875 4.00219 4.95967 3.34511 5.44414 2.86064Z",
    fill: "#08081B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocuments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Documents.de3e144dc0e511bbca69b665e086f6ec.svg";